import { requestJSON } from './http';

const list = (studentId) =>
  requestJSON(`/students/${studentId}/audit-logs`);

export default {
  list,
};
